import { Service } from "typedi";
import { getDecimalPlaces, getDivisor } from "./CurrencyRegistry";

@Service()
export class CurrencyConverter {
  convertFromMinorUnits(minorAmount: string, currencyCode: string): string {
    const numericAmount = parseInt(minorAmount, 10);

    if (isNaN(numericAmount)) {
      return this.formatAmount("0", currencyCode);
    }

    const majorAmount = numericAmount / getDivisor(currencyCode);
    return this.formatAmount(majorAmount.toString(), currencyCode);
  }

  formatAmount(majorAmount: string, currencyCode: string): string {
    const numericAmount = parseFloat(majorAmount);
    const decimalPlaces = getDecimalPlaces(currencyCode);

    if (isNaN(numericAmount)) {
      return (0).toFixed(decimalPlaces);
    }

    return numericAmount.toFixed(decimalPlaces);
  }

  getDecimalPlaces(currencyCode: string): number {
    return getDecimalPlaces(currencyCode);
  }

  getDivisor(currencyCode: string): number {
    return getDivisor(currencyCode);
  }
}
